import { render, staticRenderFns } from "./embodySuccess.vue?vue&type=template&id=edaf805e&"
import script from "./embodySuccess.vue?vue&type=script&lang=js&"
export * from "./embodySuccess.vue?vue&type=script&lang=js&"
import style0 from "./embodySuccess.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports